module.exports = __webpack_public_path__ + "img/5ae65ec9d1fd9cfba4eeb7c62092cecd.jpg";